var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('b-container',{attrs:{"fluid":"md"}},[_c('b-row',[_c('div',[_c('div',{staticClass:"left"},[_c('MinHacienda')],1)])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }